/** Manual upload from the Verifast confirm modal — blocked only while ID is in review. */
export function canChooseManualDocumentUpload(input: {
  statusReady: boolean;
  isNeedsReview: boolean;
}): boolean {
  const { statusReady, isNeedsReview } = input;
  if (!statusReady) return true;
  return !isNeedsReview;
}
